import { format } from 'date-fns';

export const TABLE_SETTINGS_STORAGE_KEY = 'applicationsTableSettings';

export const getDateRangeNumber = () => {
  const storedSettings = JSON.parse(
    localStorage?.getItem(TABLE_SETTINGS_STORAGE_KEY) || '{}',
  );
  const defaultDateFromNumber = storedSettings?.dateRange
    ? DATE_RANGE_NUMERIC_VALUES[storedSettings.dateRange]
    : 1;

  return defaultDateFromNumber || null;
};

export const getIncludePartnerChannel = () => {
  const storedSettings = JSON.parse(
    localStorage?.getItem(TABLE_SETTINGS_STORAGE_KEY) || '{}',
  );
  const defaultIncludePartnerChannel = Boolean(
    storedSettings?.includePartnerChannel,
  );

  return defaultIncludePartnerChannel;
};

export const DATE_RANGE_NUMERIC_VALUES: { [key: string]: number | null } = {
  '1 month': 1,
  '3 months': 3,
  '6 months': 6,
  'all months': null,
};

export const generateDateMonthsPrevious = (months: number | null) => {
  if (months === null) {
    return null;
  }

  const currentDate = new Date();
  const monthsDateFrom = new Date(
    currentDate.setMonth(currentDate.getMonth() - months),
  );
  const formattedDate = format(monthsDateFrom, 'yyyy-MM-dd');

  return formattedDate;
};
